export enum Steps {
  step0,
  step1,
  step2,
}

export enum errorTypes {
  deliveryType = "deliveryType",
  paymentType = "paymentType",
  name = "name",
  phone = "phone",
  email = "email",
  passport = "passport",
}

const initialState = {
  errors: [],
  basket: {},
  paymentList: [],
  deliveryList: [],
  cartShops: [],
  deliveryListAdditional: [],
  deliveryListAdditionalLoaded: false,
  sdekData: null,
  isSdekDataLoading: false,
  edostData: null,
  isEdostDataLoading: false,
  isEdostDataLoaded: false,
  params: {},
  isParamsLoaded: false,
  isBasketLoading: false,
  isBasketLoaded: false,
  isUserChangedDelivery: false,
  productShopDeliveryDays: {} as Record<string, number>,
  isProductShopDeliveryLoading: false,
  deliveryTkData: null,
  isDeliveryTkLoading: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
export const cartReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_ERRORS":
      return { ...state, errors: action.payload };
    case "SET_CART_PARAMS":
      return { ...state, params: action.payload };
    case "SET_CART_PARAM":
      return {
        ...state,
        params: {
          ...state.params,
          ...action.payload,
        },
      };
    case "SET_CART_PARAMS_LOADED":
      return { ...state, isParamsLoaded: action.payload };
    case "SET_BASKET":
      return { ...state, basket: action.payload };
    case "SET_BASKET_LOADING":
      return { ...state, isBasketLoading: action.payload };
    case "SET_BASKET_LOADED":
      return { ...state, isBasketLoaded: action.payload };
    case "SET_DELIVERY_LIST":
      return { ...state, deliveryList: action.payload };
    case "SET_DELIVERY_LIST_ADDITIONAL":
      return { ...state, deliveryListAdditional: action.payload };
    case "SET_DELIVERY_LIST_ADDITIONAL_LOADED":
      return { ...state, deliveryListAdditionalLoaded: action.payload };
    case "SET_PAYMENT_LIST":
      return { ...state, paymentList: action.payload };
    case "SET_SDEK_DATA":
      return { ...state, sdekData: action.payload };
    case "SET_SDEK_DATA_LOADING":
      return { ...state, isSdekDataLoading: action.payload };
    case "SET_EDOST_DATA":
      return { ...state, edostData: action.payload };
    case "SET_EDOST_DATA_LOADING":
      return { ...state, isEdostDataLoading: action.payload };
    case "SET_EDOST_DATA_LOADED":
      return { ...state, isEdostDataLoaded: action.payload };
    case "SET_USER_CHANGED_DELIVERY":
      return { ...state, isUserChangedDelivery: action.payload };
    case "SET_PRODUCT_SHOP_DELIVERY_DAYS":
      return { ...state, productShopDeliveryDays: action.payload };
    case "SET_PRODUCT_SHOP_DELIVERY_LOADING":
      return { ...state, isProductShopDeliveryLoading: action.payload };
    case "SET_DELIVERY_TK_DATA":
      return { ...state, deliveryTkData: action.payload };
    case "SET_DELIVERY_TK_LOADING":
      return { ...state, isDeliveryTkLoading: action.payload };
    default:
      return state;
  }
};
